import addressee from '../../defaultFieldDefinitions/Addressee';
import addressLine2 from '../../defaultFieldDefinitions/AddressLine2';
import companyName from '../../defaultFieldDefinitions/CompanyName';
import nameNumber from '../../defaultFieldDefinitions/HouseNameOrNumber';
import streetName from '../../defaultFieldDefinitions/StreetName';
import townCity from '../../defaultFieldDefinitions/TownCity';
import * as required from '../../required-validators';
import {fiveDigitsPostcodeValidator} from '../../setDigitsPostcodeValidator';
import fieldTypes from '../../../../../../enums/FieldTypes';
import PredictionsByField from '../../PredictionsByField';
import * as max from '../../max-length-validators';
import validateAutocompleteField from '../../validateAutocompleteField';

const FieldDefinitionES = [
  addressee,
  {
    name: 'postCode',
    label: 'checkout.delivery.address.field.label.postal.code.text',
    required: true,
    validate: [required.basic, fiveDigitsPostcodeValidator],
  },
  companyName,
  nameNumber,
  streetName,
  addressLine2,
  townCity,
  {
    name: 'county',
    label: 'checkout.address.field.label.county.text',
    required: true,
    element: fieldTypes.AUTOCOMPLETE,
    placeholder: 'checkout.delivery.address.field.placeholder.county.autoComplete',
    predictions: PredictionsByField.county('ES'),
    validate: [required.county, max.lengthAddress(35), validateAutocompleteField(PredictionsByField.county('ES'), 'county')],
  },
];

export default FieldDefinitionES;
